import { BrowserRouter } from "react-router-dom";
//Routes
import RoutesMap from 'happ-routes/RoutesMap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'assets/css/global.css';

//redux
import { Provider } from 'react-redux';
import store from 'happ-store';
import AppInitializaer from "happ-components/AppInitializaer/AppInitializaer";

function App() {
  return (
    <BrowserRouter>
      <Provider store={store}>
        <AppInitializaer />
        <RoutesMap />
      </Provider>
    </BrowserRouter>
  );
}

export default App;
